export default "__VITE_ASSET__CLZW0kfy__"